import {Component, OnInit, ViewChild} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {labels} from "../../../../locale/labels";
import {ListItem} from "../../../objects/listItem";
import {ListingModel} from "../../../objects/listing-model";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AppEvent} from "../../../objects/appEvent";
import {SubscriptionLike} from "rxjs";
import {SharedDataService} from "../../../services/shared-data.service";
import {MobileContainerComponent} from "../mobile-container/mobile-container.component";

@Component({
  selector: 'app-group-events-list',
  templateUrl: './group-events-list.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class GroupEventsListComponent implements OnInit {

  state: string = 'loading';
  errMsg: string = '';
  activeItem: ListItem; // Element on which was called context menu
  listing: ListingModel;
  typicalItemHeight; //94 squash_default,
  private sharedEventSubscription: SubscriptionLike;

  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;

  constructor(public application: AppComponent,
              public mobileContainer: MobileContainerComponent,
              public sharedDataService: SharedDataService,
              public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.loadItems();
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.MOBILE_STATE_CHANGE && this.application.user?.id &&
          ['squash_default','subscribe_events','cups','classes'].indexOf(appEvent.data['newState']) !== -1) {
          this.loadItems();
        }
        // if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED && this.application.user?.id) { //deprecated
        //   this.loadItems();
        // }
      });
  }
  ngOnDestroy(): void {
    this.sharedEventSubscription.unsubscribe();
  }

  private loadItems() {
    this.state = 'loading';
    this.listing = new ListingModel();

    switch (this.mobileContainer.state) {
      case 'squash_default':
        const action_types = this.application.getUrlParam('action_types');
        let events_filter = {
          action_types: action_types ? action_types : 'club_event',
          event_types: this.application.getUrlParam('event_types'),
          from: this.application.getUrlParam('from'),
          to: this.application.getUrlParam('to'),
        };
        this.application.apiService.getGroupEvents(environment['gid'],environment['g_hash'],events_filter)
          .subscribe(
            data => this.handleItems(data),
            error => this.handleItemsError(error))
        break;
      case 'subscribe_events':
        this.application.apiService.getCommunityClasses('subscribe_event',environment['gid'],environment['g_hash'])
          .subscribe(
            data => this.handleItems(data),
            error => this.handleItemsError(error))
        break;
      case 'cups':
        this.application.apiService.getCommunityClasses('cup',environment['gid'],environment['g_hash'])
          .subscribe(
            data => this.handleItems(data),
            error => this.handleItemsError(error))
        break;
      case 'classes':
        this.application.apiService.getCommunityClasses('user_class',environment['gid'],environment['g_hash'])
          .subscribe(
            data => this.handleItems(data),
            error => this.handleItemsError(error))
        break;
    }
  }
  private handleItems(items) {
    this.state = this.mobileContainer.state;
    this.listing.listItems = items;
    this.listing.sortItems('id_desc');
    this.activeItem = this.listing.listItems[0];
    switch (this.mobileContainer.state) {
      case 'squash_default':
        this.typicalItemHeight = 94;
        setTimeout(() => {
          // better to set viewport size explicitly vs some extra bottom offset
          this.viewport.setTotalContentSize(this.typicalItemHeight * (this.listing.listItems.length + 0.2))
        });
        break;
      case 'subscribe_events':
        break;
      case 'cups':
        break;
      case 'classes':
        break;
    }

  }
  private handleItemsError(error) {
    console.log('GroupEventsListComponent',error)
    this.state = 'error';
    this.errMsg = error.errMsg;
  }

  private clickOnClass(event, targetItem: ListItem) {
    this.application.router.navigateByUrl('/squash/classview/'+targetItem['itemFullData']['id'])
  }
  private clickOnClassShare(event, targetItem: ListItem) {
    let config = JSON.parse(targetItem['itemFullData']['configuration'])
    window.open(config['link'])
  }
}
